// extracted by mini-css-extract-plugin
export var lightbulb = "lightbulb-module--lightbulb--SculI";